export enum StepCreateOrg {
    StepOrgForm = "org",
    StepUserForm = "user",
    StepOverview = "overview",
}

export enum StepCreateUser {
    StepUserForm = "user",
    StepOverview = "overview",
}